/**
 * A parsed error that contains a sensible message for the user.
 */
export class NloError extends Error {
	isFatal: boolean;

	constructor(options: { message: string; cause?: any; isFatal?: boolean }) {
		super(options.message, { cause: options.cause });

		this.isFatal = options.isFatal || false;
	}
}
